module.exports = __webpack_public_path__ + "img/Aurubis.79609443.jpg";